import { useMemo } from 'react';

import { CookiesService } from '@multitenancy-spa/cookies-service';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

const useSaveBuildsUserId = () => {
	const gaId = useMemo(
		() =>
			CookiesService.getCookie('_ga') ??
			EnvVarsService.getVar('VITE_GA_USER_ID', true),
		[],
	);

	const userId = useMemo<string | undefined>(() => {
		if (!gaId) return undefined;

		const gaIdParts = String(gaId).split('.');

		if (gaIdParts.length < 2) return undefined;

		return gaIdParts.slice(Math.max(gaIdParts.length - 2, 1)).join('.');
	}, [gaId]);

	return userId;
};

export default useSaveBuildsUserId;
